import { SnackbarStatus } from '@weareopenr/component-library';
import { PublishType } from './types';
import getPublishTypeLabel from './utilities/getPublishTypeLabel';

export const successNotification = (publishType: PublishType, scheduleTime: string | undefined) =>
  ({
    status: SnackbarStatus.SUCCESS,
    message: `You have successfully ${scheduleTime ? 'scheduled ' : 'published '}${getPublishTypeLabel(publishType)}.`,
  }) as const;

export const errorNotification = (publishType: PublishType, scheduleTime: string | undefined, error?: string) =>
  ({
    status: SnackbarStatus.ERROR,
    message: `Something went wrong whilst ${scheduleTime ? 'scheduling ' : 'publishing '}${getPublishTypeLabel(publishType)}${error ? `: ${error}` : ''}.`,
  }) as const;
